import { trpc, TrpcOutputs } from '../config/trpc';

/**
 * Only the quote detail query selects `request.booked_quote_variant` and `is_api_generated`,
 * so alternative flights can only ever be offered from a quote loaded by `getQuote`.
 */
type Quote = TrpcOutputs['getQuote'];

export const useCanChangeFlight = (quote?: Quote) => {
  const isBooked = !!quote?.request?.booked_quote_variant;
  const requestId = quote?.request_id;
  const providerId = quote?.provider_id;
  const isApiGenerated = !!quote?.is_api_generated;

  const { data } = trpc.getAlternativeFlights.useQuery(
    {
      request_id: requestId ?? 0,
      provider_id: providerId ?? '',
      limit: 2,
      offset: 0,
    },
    {
      enabled: Boolean(requestId && providerId && isApiGenerated && !isBooked),
      staleTime: 5 * 60 * 1000,
      refetchOnWindowFocus: false,
    },
  );

  const hasFlightsToSelect = (data?.total_count ?? 0) > 1;

  return !isBooked && isApiGenerated && hasFlightsToSelect;
};
